/* ============================================
   PDP DATA TABLE — desktop tabs + mobile accordion
   ============================================ */

(function () {
  const MOBILE_BP = 768;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BP + 'px)').matches;
  }

  class PDPDataTable {
    constructor(root) {
      this.root = root;
      this.items = Array.from(root.querySelectorAll('.pdp-data-table-item'));
      if (this.items.length === 0) return;

      this.tabs = this.items.map((item) => item.querySelector('.pdp-data-table-tab'));
      this.panes = this.items.map((item) => item.querySelector('.pdp-data-table-pane'));
      this.mobileMode = root.dataset.mobileMode === 'multiple' ? 'multiple' : 'single';

      // Mark single-tab variant
      if (this.items.length === 1) root.classList.add('pdp-data-table--single');

      this.attachListeners();
      this.applyResponsive();
      window.addEventListener('resize', () => this.applyResponsive());
    }

    applyResponsive() {
      this.root.classList.toggle('pdp-data-table--mobile', isMobile());
    }

    attachListeners() {
      this.items.forEach((item, index) => {
        const tab = this.tabs[index];
        if (!tab) return;
        tab.addEventListener('click', () => this.handleClick(index));
      });
    }

    handleClick(index) {
      const item = this.items[index];
      const tab = this.tabs[index];
      const pane = this.panes[index];
      if (!item || !tab) return;

      const isOpen = item.classList.contains('is-active');
      const mobile = isMobile();

      if (mobile) {
        // Accordion: respect single vs multiple mode, allow collapse on re-click
        if (this.mobileMode === 'single') {
          this.items.forEach((it, i) => {
            if (i !== index) {
              it.classList.remove('is-active');
              if (this.tabs[i]) this.tabs[i].classList.remove('pdp-data-table-tab--active');
              if (this.panes[i]) this.panes[i].classList.remove('pdp-data-table-pane--active');
              if (this.tabs[i]) this.tabs[i].setAttribute('aria-expanded', 'false');
            }
          });
        }
        item.classList.toggle('is-active', !isOpen);
        tab.classList.toggle('pdp-data-table-tab--active', !isOpen);
        if (pane) pane.classList.toggle('pdp-data-table-pane--active', !isOpen);
        tab.setAttribute('aria-expanded', String(!isOpen));
      } else {
        // Desktop: switch active tab; always one open
        this.items.forEach((it, i) => {
          const active = i === index;
          it.classList.toggle('is-active', active);
          if (this.tabs[i]) {
            this.tabs[i].classList.toggle('pdp-data-table-tab--active', active);
            this.tabs[i].setAttribute('aria-expanded', String(active));
          }
          if (this.panes[i]) this.panes[i].classList.toggle('pdp-data-table-pane--active', active);
        });
      }
    }
  }

  function init() {
    document.querySelectorAll('.pdp-data-table').forEach((root) => {
      if (root.__pdpDataTableInited) return;
      root.__pdpDataTableInited = true;
      new PDPDataTable(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
